export default "__VITE_ASSET__Dp0_AMZx__"